// extracted by mini-css-extract-plugin
export default {"container":"help_container__QpSjP","icon":"help_icon__GwvMa","headingContainer":"help_headingContainer__wBvg+"};